const sizeConfigs = {
  sidebar: {
    width: "265px",
  },
};

export default sizeConfigs;
